import { Box, FormControl, Grid, Select } from "@material-ui/core";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { CxQuestion } from "../../entity/entities";
import { changeDropdown } from "./inputAnswerSlice";
import { QuestionText } from "./QuestionText";
import { useTranslation } from "react-i18next";

export function Dropdown(props: {
  pageIndex: number,
  questionIndex: number,
  cxQuestion: CxQuestion,
}) {

  const dispatch = useAppDispatch();

  // FIXME 本来はpageIndexを取得するhookを作るべき
  const {
    pageIndex,
    questionIndex,
    cxQuestion,
  } = props;
  const { t } = useTranslation();
  const value = useAppSelector(state => {

    const cxQuestionPage = state.inputAnswer.answer.cxAnswerPageDtos[pageIndex];
    const cxAnswer = cxQuestionPage.cxAnswers[questionIndex];

    return cxAnswer.answerStr || '';
  });

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {

    dispatch(changeDropdown({
      pageIndex,
      questionIndex,
      value: event.target.value as string,
    }));
  };

  const options = cxQuestion.cxQuestionOptions.map(questionOption => {
    return (
      <option
        key={questionOption.id}
        value={questionOption.optionText}
      >
        {questionOption.optionText}
      </option>
    );
  });

  return (
    <>
      <QuestionText cxQuestion={cxQuestion} />
      <Box mx={6}>
        <Grid container>
          <Grid item xs={12}>
            <FormControl variant="outlined">
              <Select
                native
                value={value}
                onChange={handleChange}
              >
                <option aria-label="None" value="">{t('question.please_select')}</option>
                {options}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}